<template>
  <DropDown v-bind:field="fieldWithOptions"
    v-bind:value="value"
    v-on:input="updateField"/>
</template>

<script>
import DropDown from '@/components/inputs/simple/DropDown.vue';
import InputMixin from '@/mixins/InputMixin';
import USStates from '@/components/inputs/complex/USStateSelector/USStates';

/**
 * US State Selector
 * -- Implements v-model
 *
 * A dropdown input that has US states for it's options.
 */
export default {
  name: 'USStateSelector',
  components: {
    DropDown,
  },
  mixins: [
    InputMixin,
  ],
  props: {
    disabled: Boolean,
  },
  computed: {
    /**
     * Return the field object, but with USStates set as the options param.
     * @return {*}
     */
    fieldWithOptions() {
      return Object.assign({}, this.field, { options: USStates });
    },
  },
  methods: {
    /**
     * Emits the `input` event with the data given
     * @param event The data to emit with the input event
     */
    updateField(event) {
      this.$emit('input', event);
    },
  },
};
</script>
